import React from 'react';
import { classNames } from 'util/utils';

import './title.less';

function Heading(props) {
  const { title, children, className } = props;

  return <h2 className={classNames([`mainHeadingTitle`, className])}>{children ?? title}</h2>;
}

export default React.memo(Heading);
